import { ApplicationData } from "types"
import { CREIGHTON_DATA } from "data/colleges/creighton/creighton"
import { SIENA_DATA } from "data/colleges/siena/siena"
import { VANGUARD_DATA } from "data/colleges/vanguard/vanguard"
import { HOLLINS_DATA } from "data/colleges/hollins/hollins"
import { TWO_OCEAN_DATA } from "data/colleges/_two_ocean/two_ocean"

export type CollegeName = "siena" | "vanguard" | "creighton" | "hollins"

export type College = {
  name: CollegeName | "twoOcean"
  data: ApplicationData
  collegeId: string
  currentlyActive?: boolean
}

export const COLLEGES: College[] = [
  {
    name: "siena",
    data: SIENA_DATA,
    collegeId: "c4d98d82-cf99-4d92-b6ae-63c776a1f38d",
    currentlyActive: true
  },
  {
    name: "creighton",
    data: CREIGHTON_DATA,
    collegeId: "33d2d7d0-c421-47c9-aeb8-4dc1cf54ce3b",
  },
  {
    name: "twoOcean",
    data: TWO_OCEAN_DATA,
    collegeId: "40fb5a70-4ab3-4f65-aa4a-e4fd088a114f",
  },
  {
    name: "vanguard",
    data: VANGUARD_DATA,
    collegeId: "194e9323-f2ab-4e7e-a571-43d7c8bd1389"
  },
  {
    name: "hollins",
    data: HOLLINS_DATA,
    collegeId: "0c34ecc1-968c-424d-a560-5102147fd050"
  }
]

export const TEST_DATA = TWO_OCEAN_DATA

//keys to transform plain object to object with nested structures
export const COLLEGE_NESTED_FIELDS = {
  siena: ["parent", "alumni", "institution", "course"],
  vanguard: ["parent", "alumni"],
  creighton: ["parent", "alumni", "sibling", "extracurricular", "institution"],
  hollins: ["parent", "sibling", "alumni"],
}

//keys to transform from nested structures to plain object
export const COLLEGE_NESTED_FIELDS_TO_PLAIN_OBJECT = {
  siena: [
    { key: "parent_existence", dependencyKey: "parents" },
    { key: "alumni_shared", dependencyKey: "alumnis" },
    { key: "institution_attended", dependencyKey: "institutions" },
    { key: "course_taken", dependencyKey: "courses" },
  ],
  vanguard: [
    { key: "parent_existence", dependencyKey: "parents" },
    { key: "alumni_shared", dependencyKey: "alumnis" },
  ],
  creighton: [
    { key: "parent_existence", dependencyKey: "parents" },
    { key: "alumni_shared", dependencyKey: "alumnis" },
    { key: "institution_attended", dependencyKey: "institutions" },
    { key: "sibling_existence", dependencyKey: "siblings" },
    {
      key: "extracurricular_activity_taken",
      dependencyKey: "extracurriculars",
    },
  ],
  hollins: [
    { key: "parent_existence", dependencyKey: "parents" },
    { key: "alumni_shared", dependencyKey: "alumnis" },
    { key: "sibling_existence", dependencyKey: "siblings" },
  ],
}
